/**
 * Copyright (C) 2022 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import { Box } from '@mui/system';
import styled from 'styled-components';
import appTheme from '../common/theme/appTheme.json';

export const DATA_USAGE_HEADER_HEIGHT = 72;
export const DATA_USAGE_HEADER_WIDTH = '100%';

const DataUsageHeader = () => {
  return (
    <Box
      borderBottom={1}
      borderColor={appTheme.secondaryBackgroundColor}
      sx={{
        width: DATA_USAGE_HEADER_WIDTH,
        height: `${DATA_USAGE_HEADER_HEIGHT}px`,
        backgroundColor: appTheme.primaryBackgroundColor,
        padding: '16px',
        boxSizing: 'border-box',
      }}
    >
      <StyledDataUsageHeading>Historical reports</StyledDataUsageHeading>
    </Box>
  );
};

export default DataUsageHeader;

export const StyledDataUsageHeading = styled.h1`
  font-family: ${appTheme.viasatFontFamilyRegular};
  color: ${appTheme.primaryTextColor};
  font-size: 32px;
  font-weight: 800;
  line-height: 40px;
  letter-spacing: 0.2px;
  margin: 0;

  @media print {
    color: black;
    margin: 0px;
  }
`;
